import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import type { ServiceRequestsView } from '@meddihub/mzcr-ui';
import { store } from '../../../store/store';
import { loadDOMComponent } from '../../../helpers';
import { AppContextProvider } from '../../../Services/AppContext';
import AclContextProvider from '../../Acl/Components/AclContextProvider';
import MzcrServiceRequestsPage from './MzcrServiceRequestsPage';

type ServiceRequestsLinks = Record<ServiceRequestsView, string>;

const VIEWS: ServiceRequestsView[] = ['new', 'sent', 'received'];

const parseView = (value: string | null): ServiceRequestsView =>
	VIEWS.find(view => view === value) ?? 'sent';

const parseLinks = (value: string | null): ServiceRequestsLinks => {
	try {
		return JSON.parse(value ?? '{}');
	} catch (e) {
		console.error(e);
		return { new: '', sent: '', received: '' };
	}
};

loadDOMComponent({
	selector: 'react-mzcr-service-requests',
	callback: ({
		container,
		context,
	}: {
		container: HTMLElement;
		context: React.ComponentProps<typeof AppContextProvider>;
	}) => {
		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider {...context}>
					<AclContextProvider>
						<MzcrServiceRequestsPage
							view={parseView(container.getAttribute('view'))}
							links={parseLinks(container.getAttribute('links'))}
							workplaceName={
								container.getAttribute('workplace-name') || undefined
							}
						/>
					</AclContextProvider>
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
